import { render, staticRenderFns } from "./DebriefForm.vue?vue&type=template&id=4f023d0e&scoped=true&"
import script from "./DebriefForm.vue?vue&type=script&lang=js&"
export * from "./DebriefForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f023d0e",
  null
  
)

export default component.exports